import { useLocalesContext } from "@/contexts/Locale";
import { SHIPPING_COUNTRIES_QUERY } from "@/graphql/shop";
import ShippingCountrySelect from "@/tpo/ShippingCountrySelect";
import { useQuery } from "@apollo/client";

export default function LocaleSwitcher() {
  const { locale, setLocale } = useLocalesContext();
  const { data } = useQuery(SHIPPING_COUNTRIES_QUERY);

  return (
    <ShippingCountrySelect
      name="shopShippingCountry"
      label=""
      placeholder="Select a country"
      valueField="isoCode"
      fullWidth
      value={locale?.isoCode ?? ""}
      onChange={event => {
        const isoCode = event.target.value;
        if (!isoCode) {
          return;
        }
        const country = data?.shippingCountries?.find(c => c.isoCode === isoCode);
        if (country) {
          setLocale({
            id: country.id,
            isoCode: country.isoCode
          });
        }
      }}
    />
  );
}
